angular.module("dropbox-picker", []).provider("DropBoxSettings", function() {
        this.box_linkType = 'shared', this.box_multiselect = 'true', this.box_clientId = null, this.linkType = 'preview', this.multiselect = false, this.extensions = ['.pdf', '.doc', '.docx'], this.$get = function() {
                return {
                    linkType: this.linkType,
                    multiselect: this.multiselect,
                    extensions: this.extensions,
                    box_linkType: this.box_linkType,
                    box_multiselect: this.box_multiselect,
                    box_clientId: this.box_clientId

                }
            },
            this.configure = function(e) {
                for (key in e) this[key] = e[key]
            }

    })
    .directive("dropBoxPicker", ["DropBoxSettings",
        function(DropBoxSettings) {
            return {
                restrict: "A",
                scope: {
                    onDropboxCancel: '&',
                    onDropboxSuccess: '&'
                },
                link: function(scope, element, attrs) {
                    function instanciate() {
                        Dropbox.choose(dropboxOptions);
                    }
                    var dropboxOptions = {
                        success: dropboxsuccess,
                        cancel: dropboxcancel,
                        linkType: DropBoxSettings.linkType,
                        multiselect: DropBoxSettings.multiselect,
                        extensions: DropBoxSettings.extensions,
                    };

                    function dropboxsuccess(files) {
                        (scope.onDropboxSuccess || angular.noop)({ files: files });
                        scope.$apply();
                    };

                    function dropboxcancel() {
                        (scope.onDropboxCancel || angular.noop)();
                        scope.$apply();
                    };
                    element.bind("click", function() {
                        instanciate()
                    })
                }
            }
        }
    ])
    .directive("boxPicker", ["DropBoxSettings",
        function(DropBoxSettings) {
            return {
                restrict: "A",
                scope: {
                    onBoxCancel: '&',
                    onBoxSuccess: '&'
                },
                link: function(scope, element, attrs) {
                    function instanciate() {
                        var success = false;
                        var boxSelect = new BoxSelect(boxoptions);
                        boxSelect.launchPopup();
                        boxSelect.success(function(files) {
                            if (!success) {
                                boxSelect.closePopup();
                                (scope.onBoxSuccess || angular.noop)({ files: files });
                                scope.$apply();
                                //boxSelect.unregister(boxSelect.SUCCESS_EVENT_TYPE, successCallbackFunction);
                                success = true
                            }
                        });
                        boxSelect.cancel(function() {
                            boxSelect.closePopup();
                            (scope.onBoxCancel || angular.noop)();
                            scope.$apply();
                        });
                    }

                    function successCallbackFunction() {
                        boxSelect.closePopup();
                    }

                    var boxoptions = {
                        clientId: DropBoxSettings.box_clientId,
                        linkType: DropBoxSettings.box_linkType,
                        multiselect: DropBoxSettings.box_multiselect
                    };
                    element.bind("click", function() {
                        instanciate()
                    })
                }
            }
        }
    ])